// User action tracking utility
import API from './api';

/**
 * Records user actions for analytics and tracking purposes
 * @param {string} actionType - The type of action performed (e.g., 'show_answer', 'give_hint')
 * @param {object} actionData - Additional data about the action
 */
export const recordAction = async (actionType, actionData = {}) => {
  try {
    // Get user ID from local storage
    const userId = localStorage.getItem('userId');
    const roomNumber = localStorage.getItem('roomNumber');
    const storyId = localStorage.getItem('storyId');
    
    if (!userId || !storyId) {
      console.warn('Cannot record action: missing userId or storyId');
      return false;
    }
    
    // Determine question index if available
    const questionIndex = typeof actionData.questionId === 'string' 
      ? parseInt(actionData.questionId.replace('q', ''), 10) || 0
      : actionData.questionIndex || 0;
    
    // Create action payload
    const payload = {
      userId,
      storyId,
      questionIndex,
      actionType,
      actionDetails: actionData,
      correctAnswer: actionData.isCorrect || false
    };
    
    // Log the action to console for debugging
    console.log('ACTION RECORDED:', payload);
    
    // Send to backend API
    try {
      const response = await API.post('/user-actions/record', payload);
      
      if (response.data && response.data.success) {
        console.log('User action successfully recorded on server');
        return true;
      } else {
        console.warn('Failed to record user action on server:', response.data?.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error sending action to server:', error);
      // Continue execution even if API call fails
    }
    
    return true;
  } catch (error) {
    console.error('Failed to record user action:', error);
    return false;
  }
};
